/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListInvitesSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListInvitesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListInvitesSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListInvitesSecurity$outboundSchema: z.ZodMiniType<
  ListInvitesSecurity$Outbound,
  ListInvitesSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listInvitesSecurityToJSON(
  listInvitesSecurity: ListInvitesSecurity,
): string {
  return JSON.stringify(
    ListInvitesSecurity$outboundSchema.parse(listInvitesSecurity),
  );
}

/** @internal */
export type ListInvitesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListInvitesRequest$outboundSchema: z.ZodMiniType<
  ListInvitesRequest$Outbound,
  ListInvitesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listInvitesRequestToJSON(
  listInvitesRequest: ListInvitesRequest,
): string {
  return JSON.stringify(
    ListInvitesRequest$outboundSchema.parse(listInvitesRequest),
  );
}
